import lodash from 'lodash';

const state = () => ({
  userAppData: [],
  loadingAppData: true
});

const getters = {
  userAppData(state) {
    return state.userAppData;
  },
  loadingAppData(state) {
    return state.loadingAppData;
  }
};

const mutations = {
  setUserAppData(state, payload) {
    state.userAppData = payload;
  },
  updateLocaleUserAppData(state, payload) {
    const userAppDataTmp = lodash.cloneDeep(state.userAppData);

    state.userAppData = [...userAppDataTmp.filter(val => val.name !== payload.name), payload];
  },
  setLoadingAppData(state, payload) {
    state.loadingAppData = payload;
  }
};

const actions = {
  setUserAppData({ commit }, payload) {
    commit('setUserAppData', payload);
  },
  updateLocaleUserAppData({ commit }, payload) {
    commit('updateLocaleUserAppData', payload);
  },
  setLoadingAppData({ commit }, payload) {
    commit('setLoadingAppData', payload);
  }
};

export const userAppData = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
